<template>
  <div class="page-content" id="retained">
    <div>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <span @click="jump('/custormTable')">报表模板</span>
        </el-breadcrumb-item>
        <!-- <el-breadcrumb-item>
          <span @click="jump('/custormTable/previewTable')">报表模板</span>
          </el-breadcrumb-item> -->
        <el-breadcrumb-item>导出报表</el-breadcrumb-item>
      </el-breadcrumb>

      <div class="page">
        <el-table
          @selection-change="handleSelectionChange"
          :data="tableData"
          ref="multipleTable"
          v-loading="dataLoading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          style="width: 100%"
        >
          <el-table-column type="selection"></el-table-column>
          <el-table-column label="序号" type="index"></el-table-column>
          <el-table-column label="报表名称" prop="tablename"></el-table-column>
          <el-table-column label="导出人" prop="exportusername"></el-table-column>
          <el-table-column label="导出时间" prop="exporttime"></el-table-column>
          <el-table-column align="right" label="操作">
            <template slot-scope="scope">
              <el-button type="text" :disabled="scope.row.status == 0" @click="download(scope.row)">下载</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div v-show="this.tableData.length >= 1">
          <pagination
            :currentPage="currentPage"
            :pageSizes="[10, 20, 50, 100]"
            :total="totalNum"
            @handleSizeChange="handleSizeChange"
            @handleCurrentChange="handleCurrentChange"
          >
          </pagination>
        </div>
        <!-- 下载 -->
        <el-dialog
          title="下载"
          :visible.sync="showDownload"
          width="360px"
          style="margin-top: 10%"
          id="dialog"
        >
          <div style="display: flex; width: 100%; justify-content: center">
            <i
              class="el-icon-warning"
              style="color: #faad14; font-size: 35px"
            ></i>
            <div>
              <div style="font-size: 16px">
                导出数据需要等待一会，需进入 导出记录 查看导出结果。
              </div>
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" size="small">查看导出记录</el-button>
            <el-button @click="delCancel" size="small" type="TheCustom"
              >取 消</el-button
            >
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

  <script>
import pagination from "@/components/dataTable/pagination";
export default {
  data() {
    return {
      previewId: null,
      id: "",
      checkAll: "",
      showDownload: false,
      dataLoading: false,
      pageNum: 1,
      currentPage: 1,
      pageSize: 10,
      tableData: [],
      selectRows: [],
      totalNum: 100,
      openNumber: 0,
      bmcid: '',
    };
  },
  mounted() {
    this.getBmcListByKefuid()

  },
  methods: {
    getBmcListByKefuid(){
      fetch({
        url: "hcm/userin/getBmcListByKefuid",
        method: "get",
        noFormat: true,
        responseType: "text"
      }).then((res)=>{
        let result=JSON.parse(res)
        if(result.status=='10000'){
          for(let item of result.data){
            if(item.checked=='true'){
              this.bmcid=Number(item.bmcid)
              localStorage.setItem('bmcKefuid',this.Kefuid);
              localStorage.setItem('bmcKefuName',item.company_memoname);
            }
          }
          this.theQuery();
          this.previewId = this.$route.query.id;
        }
      })
    },
    jump(url) {
      this.$router.push(url);
    },

    // 下载
    download(val) {
      window.open('https://console.olonger.com/report/'+val.exporturl)
    },

    // 翻页
    handleCurrentChange(val) {
      this.pageNum = `${val}`;
      this.theQuery();
    },
    // 翻页
    handleSizeChange(val) {
      this.pageSize = `${val}`;
      this.theQuery();
    },
    // 数据源
    theQuery() {
      this.dataLoading = true;
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        bmcid: this.bmcid,
      };
      fetch({
        url: "/report/report/log/list",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text",
      }).then((result) => {
        let res = JSON.parse(result);
        if (res.code == 200) {
          this.dataLoading = false;
          this.tableData = res.rows;
          this.totalNum = res.total;
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },

    handleSelectionChange(val) {
      if (this.checkAll != 2) {
        this.openNumber = val.length;
        this.selectRows = val;
      }
    },

    // 取消删除
    delCancel() {
      this.showDownload = false;
      this.checkAll = "";
    },
  },
  components: {
    pagination,
  },
};
</script>
  <style lang="scss" scoped>
  .op-btn{
    cursor: pointer;
    color: #3f9eff;
  }
#retained {
  .el-table__empty-text {
    padding-top: 100px;
    background-position: center 66px;
  }
  .el-table th {
    background-color: #f2f6fe !important;
    color: #4a4b4c;
  }
  .page {
    padding: 20px;
    margin: 10px 0px 0px 0px;
    background-color: white;
  }

  #dialog {
    .el-button--primary {
      color: #fff;
      background-color: #bda571;
      border-color: #bda571;
    }
    .el-button--primary:hover {
      color: #fff;
      background-color: #c0ae8a;
      border-color: #c0ae8a;
    }
  }
  .el-button--TheCustom {
    color: #666;
    border-color: #d9d9d9;
    background-color: #fff;
  }
  .el-button--TheCustom:hover {
    color: #666;
    border-color: #ded2b8;
    background-color: #faf9f5;
  }
  .downBtn {
    display: flex;
    justify-content: flex-start;
  }

  .prompt {
    height: 28px;
    border: 1px solid #108cee;
    background-color: #e6f7ff;
    border-radius: 5px;
    line-height: 28px;
    margin-top: 8px;
    margin-bottom: 8px;
  }
  .promptFont {
    color: #108cee;
    font-size: 14px;
    margin-left: 3px;
    margin-right: 3px;
  }
  .promptFont2 {
    color: #108cee;
    font-size: 14px;
    margin-left: 3px;
    margin-right: 3px;
    cursor: pointer;
  }
  .plat-item {
    display: inline-block;
    margin-left: 5px;
    border: 1px solid rgb(164, 163, 163);
    padding: 2px;
    border-radius: 4px;
  }
  .threeHa {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
}
</style>
